// Bilingual content for ClassOne Vintage
export const COLLECTIONS = [
  { slug: "nouveautes", fr: "Nouveautés", en: "New Arrivals" },
  { slug: "tops", fr: "Tops", en: "Tops" },
  { slug: "baggy-jeans", fr: "Baggy Jeans", en: "Baggy Jeans" },
  { slug: "baggy-jorts", fr: "Baggy Jorts", en: "Baggy Jorts" },
  { slug: "jackets", fr: "Jackets", en: "Jackets" },
  { slug: "sweats", fr: "Sweats", en: "Sweats" },
  { slug: "knitwear", fr: "Knitwear", en: "Knitwear" },
  { slug: "crews", fr: "Crews", en: "Crews" },
  { slug: "button-up-shirts", fr: "Button-Up Shirts", en: "Button-Up Shirts" },
];

export const t = {
  nav: {
    home: { fr: "Accueil", en: "Home" },
    shop: { fr: "Boutique", en: "Shop" },
    collections: { fr: "Collections", en: "Collections" },
    about: { fr: "À propos", en: "About" },
    contact: { fr: "Contact", en: "Contact" },
    dossier: { fr: "Brand Kit", en: "Brand Kit" },
  },
  hero: {
    eyebrow: { fr: "Streetwear vintage · Édition limitée", en: "Vintage streetwear · Limited edition" },
    title: { fr: "Le vintage, porté avec calme.", en: "Vintage, worn with calm." },
    sub: {
      fr: "Des pièces amples, des tons neutres, une sélection rare. ClassOne Vintage habille le quotidien avec une élégance discrète et durable.",
      en: "Relaxed cuts, neutral tones, a rare selection. ClassOne Vintage dresses the everyday with quiet, lasting elegance.",
    },
    cta: { fr: "Découvrir la boutique", en: "Explore the shop" },
    cta2: { fr: "Voir les Crews", en: "View Crews" },
  },
  sections: {
    new: { fr: "Nouveautés", en: "New Arrivals" },
    newSub: { fr: "Les dernières pièces entrées en collection.", en: "The latest pieces added to the collection." },
    unique: { fr: "Pièces Uniques", en: "Unique Pieces" },
    uniqueSub: { fr: "Un seul exemplaire. Une fois parti, c'est fini.", en: "A single piece. Once gone, it's gone." },
    aesthetic: { fr: "Notre Esthétique", en: "Our Aesthetic" },
    aestheticBody: {
      fr: "Nous croyons au vêtement qui dure. Des coupes amples qui laissent respirer, des tons neutres qui ne se démodent jamais, une matière qui raconte une histoire. Chaque pièce est choisie pour sa qualité, son confort et son caractère — jamais pour la tendance.",
      en: "We believe in clothing that lasts. Relaxed cuts that let you breathe, neutral tones that never date, materials that tell a story. Each piece is chosen for its quality, comfort and character — never for the trend.",
    },
    viewAll: { fr: "Tout voir", en: "View all" },
  },
  marquee: { fr: "TONS NEUTRES · COUPES AMPLES · PIÈCES RARES · QUALITÉ DURABLE · ", en: "NEUTRAL TONES · RELAXED CUTS · RARE PIECES · LASTING QUALITY · " },
  product: {
    add: { fr: "Ajouter au panier", en: "Add to cart" },
    details: { fr: "Détails & Mesures", en: "Details & Measurements" },
    condition: { fr: "Condition vintage", en: "Vintage condition" },
    styling: { fr: "Conseils de style", en: "Styling tips" },
    stylingBody: {
      fr: "Associez cette pièce à des tons neutres et des volumes simples. Roulez les manches, jouez le contraste mat, laissez la silhouette respirer.",
      en: "Pair this piece with neutral tones and simple volumes. Roll the sleeves, play matte contrast, let the silhouette breathe.",
    },
    unique: { fr: "Pièce unique", en: "One of one" },
    new: { fr: "Nouveau", en: "New" },
    back: { fr: "Retour", en: "Back" },
  },
  cart: {
    title: { fr: "Votre Panier", en: "Your Cart" },
    empty: { fr: "Votre panier est vide.", en: "Your cart is empty." },
    continue: { fr: "Continuer mes achats", en: "Continue shopping" },
    subtotal: { fr: "Sous-total", en: "Subtotal" },
    checkout: { fr: "Passer la commande", en: "Checkout" },
    remove: { fr: "Retirer", en: "Remove" },
    shipping: { fr: "Frais de livraison calculés à l'étape suivante.", en: "Shipping calculated at the next step." },
  },
  contact: {
    title: { fr: "Contact", en: "Contact" },
    intro: {
      fr: "Une question sur une pièce, une taille, une commande ? Écrivez-nous. Nous répondons sous 24h, du lundi au vendredi.",
      en: "A question about a piece, a size, an order? Write to us. We reply within 24h, Monday to Friday.",
    },
    name: { fr: "Nom", en: "Name" },
    email: { fr: "Courriel", en: "Email" },
    message: { fr: "Message", en: "Message" },
    send: { fr: "Envoyer", en: "Send" },
    sent: { fr: "Message envoyé. Merci !", en: "Message sent. Thank you!" },
  },
};

export const ABOUT = {
  fr: {
    title: "À propos de ClassOne Vintage",
    blocks: [
      { h: "Notre histoire", p: "ClassOne Vintage est né d'une obsession simple : retrouver les vêtements qui durent. Fatigués du jetable, nous avons commencé à chiner des pièces oubliées — amples, neutres, solides — pour leur offrir une seconde vie. Aujourd'hui, chaque pièce est sélectionnée à la main, nettoyée et photographiée avec soin, depuis le Canada." },
      { h: "Notre mission", p: "Rendre le vintage premium accessible et désirable. Proposer une garde-robe calme, intemporelle et responsable, loin du bruit des tendances." },
      { h: "Nos valeurs", p: "Qualité avant quantité. Transparence sur l'état de chaque pièce. Respect du vêtement et de ceux qui le portent. Une esthétique cohérente, du produit jusqu'à l'emballage." },
      { h: "Pourquoi le vintage ?", p: "Parce qu'une pièce vintage a déjà fait ses preuves. Elle a une matière, une coupe et une âme qu'on ne fabrique plus. Choisir le vintage, c'est choisir le durable sans renoncer au style." },
    ],
  },
  en: {
    title: "About ClassOne Vintage",
    blocks: [
      { h: "Our story", p: "ClassOne Vintage was born from a simple obsession: finding clothing that lasts. Tired of the disposable, we began sourcing forgotten pieces — relaxed, neutral, durable — to give them a second life. Today, each piece is hand-selected, cleaned and carefully photographed, from Canada." },
      { h: "Our mission", p: "To make premium vintage accessible and desirable. To offer a calm, timeless and responsible wardrobe, far from the noise of trends." },
      { h: "Our values", p: "Quality over quantity. Transparency about each piece's condition. Respect for the garment and those who wear it. A consistent aesthetic, from product to packaging." },
      { h: "Why vintage?", p: "Because a vintage piece has already proven itself. It has a material, a cut and a soul that's no longer made. Choosing vintage is choosing durability without giving up style." },
    ],
  },
};

export const FAQ = {
  fr: [
    { q: "Livraison (Postes Canada)", a: "Nous expédions via Postes Canada. Délais : 3 à 7 jours ouvrables au Canada, 7 à 14 jours à l'international. Un numéro de suivi vous est envoyé par courriel dès l'expédition." },
    { q: "Retours", a: "Les retours sont acceptés sous 14 jours sur les articles non portés, étiquettes intactes. Les frais de retour sont à la charge du client. Les pièces uniques sont des ventes finales." },
    { q: "Tailles", a: "Le vintage taille différemment. Fiez-vous toujours aux mesures à plat indiquées sur chaque fiche produit plutôt qu'à la taille marquée. En cas de doute, écrivez-nous." },
    { q: "Pièces uniques", a: "Chaque pièce unique existe en un seul exemplaire. Une fois vendue, elle ne sera pas réapprovisionnée. Ces pièces ne sont ni échangeables ni remboursables." },
    { q: "Délais", a: "Les commandes sont préparées sous 1 à 2 jours ouvrables. Vous recevez une confirmation puis un suivi d'expédition." },
    { q: "Entretien des vêtements vintage", a: "Lavage à froid à l'envers, cycle délicat. Séchage à l'air, à plat de préférence. Évitez le sèche-linge et le repassage direct sur les imprimés. Un entretien doux prolonge la vie de la pièce." },
  ],
  en: [
    { q: "Shipping (Canada Post)", a: "We ship via Canada Post. Timelines: 3-7 business days within Canada, 7-14 days internationally. A tracking number is emailed to you as soon as your order ships." },
    { q: "Returns", a: "Returns are accepted within 14 days on unworn items with tags intact. Return shipping is the customer's responsibility. Unique pieces are final sale." },
    { q: "Sizing", a: "Vintage fits differently. Always rely on the flat measurements listed on each product page rather than the labelled size. When in doubt, write to us." },
    { q: "Unique pieces", a: "Each unique piece exists in a single copy. Once sold, it will not be restocked. These pieces are neither exchangeable nor refundable." },
    { q: "Timelines", a: "Orders are prepared within 1-2 business days. You receive a confirmation followed by shipping tracking." },
    { q: "Caring for vintage", a: "Cold wash inside out, delicate cycle. Air dry, preferably flat. Avoid the dryer and direct ironing on prints. Gentle care extends the life of the piece." },
  ],
};
